module.exports = __webpack_public_path__ + "media/components/resources/grid/prototype/thumb2-6893848703de992aa54f91e0d347d9ab.jpg";